/* @flow strict */

import * as React from 'react';
import StripeConnection from '/client/src/components/dialogs/stripeConnection';

type PropsType = {};

const Stripe = ({}: PropsType): React.Element<'form'> => {
  return (
    <>
      <header>
        <h1>Connect to Stripe</h1>
        <h4 className="sub-header">
          Set up payments with Stripe to collect payments
        </h4>
      </header>
      <StripeConnection wellcomCb={(props) => {
        props.history.push('?wellcomeStripe');
      }}
      />
    </>
  );
};

export default Stripe;
